import React from 'react'

import PolicySecurity from '@components/PolicySecurity'

const VendorPrivacyPolicy = ({}) => {
  return <PolicySecurity contentKey='vendorPolicy' />
}

VendorPrivacyPolicy.propTypes = {}

export default VendorPrivacyPolicy
